export class CanvasConfig {
  height: string = "420";
  width: string = "560";
}